import { RouteConfig } from 'vue-router/types/router';
import SwTools from './swTools.vue';
import WifiPlanner from './wifiPlanner.vue';
import SwarmReport from './swarmReport.vue';

export const myTools: RouteConfig = {
  path: 'sw-tools',
  component: SwTools,
};

export const wifiplanner: RouteConfig = {
  path: 'wifi-planner',
  component: WifiPlanner,
};

export const swarmReport: RouteConfig = {
  path: 'swarmReport',
  component: SwarmReport,
};
